/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCreatePiiRequestResponseFromJSON(json) {
    return StreemApiCreatePiiRequestResponseFromJSONTyped(json, false);
}
export function StreemApiCreatePiiRequestResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'piiRequestSid': !exists(json, 'pii_request_sid') ? undefined : json['pii_request_sid'],
        'customIdentifier': !exists(json, 'custom_identifier') ? undefined : json['custom_identifier'],
    };
}
export function StreemApiCreatePiiRequestResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'pii_request_sid': value.piiRequestSid,
        'custom_identifier': value.customIdentifier,
    };
}
//# sourceMappingURL=StreemApiCreatePiiRequestResponse.js.map